module.exports = __webpack_public_path__ + "media/images/gift_box-d0d650b833afe436f9d63781ed35fbe5.svg";